import PrismicAdapter from "../PrismicAdapter/PrismicAdapter.js";

export default (function (){

    const defaults = {
        id: "vueApp",
    };

    let container;

    function init(options) {
        return new App(options);
    }

    const App = function(options) {

        if (typeof options !== "object") {
            options = {};
        }

        let processResponse = function(data) { return data; }

        if (typeof options.processor === "function") {
            processResponse = options.processor;
            delete options.processor;
        }

        this.callback = function(){ };

        if (typeof options.callback === "function") {
            this.callback = options.callback;
            delete options.callback;
        }

        const settings = Object.assign({}, defaults, options.settings);

        container = document.querySelector("#" + options.id);

        if (! container) {
            return;
        }

        settings.id = options.id;

        let data = {};

        if (typeof settings.data === "object") {
            data = Object.assign({}, data, settings.data);
        }

        if (typeof settings.methods !== "object") {
            settings.methods = {};
        }

        PrismicAdapter.getData({
            settings: settings,
            data: data,
            callback: (response) => {
                const data = processResponse(response);
                if (typeof data === "object") {
                    this.init(settings, data);
                }
            }
        });

    }

    App.prototype.init = function(settings, data) {

        this.data = data;
        this.data.settings = settings;

        // Init Vue

        const callback = this.callback;

        this.viewModel = new Vue({
            el: "#" + settings.id,
            data: () => {
                return this.data;
            },
            methods: settings.methods,
            mounted: function() {

                this.$nextTick(() => {
                    callback();
                });

            },
        });

        this.container = this.viewModel.$el;

    }

    return {
        init: init
    }

})();
